module.exports = __webpack_public_path__ + "media/images/new_landing/hp/irena-kobosilova-b2ac2bb371803138d355b8368fd73dd6.png";